import { render, staticRenderFns } from "./RoundedColorButton.vue?vue&type=template&id=4ef9445e&scoped=true&"
import script from "./RoundedColorButton.vue?vue&type=script&lang=js&"
export * from "./RoundedColorButton.vue?vue&type=script&lang=js&"
import style0 from "./RoundedColorButton.vue?vue&type=style&index=0&id=4ef9445e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9445e",
  null
  
)

export default component.exports